$(document).on('ready', function () {
    $('.scroll-to__bottom a').on('click', function (e) {
        const parentSection = $(this).closest('.shopify-section');
        const scrollSection = parentSection.next();
        $('html, body').animate({
            scrollTop: scrollSection.offset().top
        }, 1000);
    })
    // Slick is no longer loaded globally; only init if present and plugin exists
    if ($('.js-thumbnails-slider').length && $.fn.slick) {
        $('.js-thumbnails-slider').slick({
            vertical: true,
            verticalSwiping: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: false,
            focusOnSelect: true,
        })

        $('.js-thumbnails-slider .slick-slide').click(function(e) {
            $('.js-thumbnails-slider .slick-slide').removeClass('slick-active').removeClass('slick-current').removeClass('active');
            $(this).addClass('slick-active').addClass('slick-current').addClass('active')
        })
        $('.js-thumbnails-slider .slick-next').click(function(e) {
            let next = $('.js-thumbnails-slider .slick-current').next();
            if(next[0] !== undefined) {
                $('.js-thumbnails-slider .slick-slide').removeClass('active')
                next.addClass('active')
                $('.js-thumbnails-slider .active a')[0].click();
            }
        })
        $('.js-thumbnails-slider .slick-prev').click(function(e) {
            let prev = $('.js-thumbnails-slider .slick-current').prev();
            if(prev[0] !== undefined){
                $('.js-thumbnails-slider .slick-slide').removeClass('active')
                prev.addClass('active')
                $('.js-thumbnails-slider .active a')[0].click();
            }
        })
    }
    $('.baby__logo-icon').css('opacity', '1');
    $('#preloader.show .baby-preloader-logo .baby__logo-icon').css('opacity', '1');
    $('.baby-instagram-section  #insta-feed').on('DOMSubtreeModified',function (){
        let slides= $(this).find('.slide-page')
        console.log(slides)
       if(slides.length > 0){
             slides.each(function (index){
               let position = index+1;
               if (window.matchMedia("(max-width: 768px) and (min-width: 475px)").matches) {
                   $(this).attr("data-slide-page", Math.ceil(position/2))
               } else if (window.matchMedia("(max-width: 475px)").matches){
                   $(this).attr("data-slide-page", position)
               }else {
                   $(this).attr("data-slide-page", Math.ceil(position/4))
               }

           })
       }
    })

    if ( $('#ProductSection').length || $('.product-miniature').length ) {
        //SET THIS TO TRUE AFTER TESTING
        let sizeEnable = true;

        if (/DEVMODE/.test(window.location.href)) {
            sizeEnable = true
        }
        if (sizeEnable && $('.badge--size-tag').length) {
            const badge = $('.badge--size-tag');
            let size

            badge.each(function () {
              const badgeItem = $(this)
              if (/us.le-olive/.test(window.location.href) || /uk.le-olive/.test(window.location.href) ) {
                size = badgeItem.attr('data-us');
            } else {
                 size = badgeItem.attr('data-eu');
            }

            if ( size.length ) {
                badgeItem.find('span').html(size);
                badgeItem.removeClass('hidden');
            }
            })
            


        }
    }

    if ( $('.hidden__grid-item').length ) {
        $('.hidden__grid-item').remove();
    }
})
$( window ).resize(function (){
    let instagrabBlock = $('.baby-instagram-section  #insta-feed')
    let slides= instagrabBlock.find('.slide-page')
    if(slides.length > 0){
        slides.each(function (index){
            console.log("asdasd")
            let position = index+1;
            if (window.matchMedia("(max-width: 768px) and (min-width: 475px)").matches) {
                $(this).attr("data-slide-page", Math.ceil(position/2))
            } else if (window.matchMedia("(max-width: 475px)").matches){
                $(this).attr("data-slide-page", position)
            }else {
                $(this).attr("data-slide-page", Math.ceil(position/4))
            }
        })
        instagrabBlock.find('.slide-page').css('display','none');
        instagrabBlock.find('.slide-page[data-slide-page="1"]').css('display','initial');
    }
})
// Keep struck-through compare price aligned with option extras.
// Prefer the shared refresher (handles sale + compare together).
$(document).on('DOMSubtreeModified', '.product-single__price', function () {
  if (typeof window.leOliveRefreshProductOptionPrice === 'function') {
    // Avoid re-entry loops from our own text writes.
    if (window.__loComparePriceWriting) return;
    return;
  }
  var $price = $(this);
  var currency = $('body').attr('data-currency-symbol') || '€';
  var price = parseFloat(
    String($price[0].innerHTML || '')
      .replace(currency, '')
      .replace(/\./g, '')
      .replace(',', '.')
  );
  var $wrap = $price.closest('.product-single__prices');
  var originalPrice = parseFloat(
    String($wrap.attr('data-original-price') || '')
      .replace(/\./g, '')
      .replace(',', '.')
  );
  var $compare = $wrap.find('.product-single__price--compare');
  if (!$compare.length || !isFinite(price) || !isFinite(originalPrice)) return;

  var compareBaseRaw = $compare.attr('data-original-compare');
  if (!compareBaseRaw) {
    compareBaseRaw = $compare.attr('content') || $compare.text();
    $compare.attr('data-original-compare', compareBaseRaw);
  }
  var compareBase = parseFloat(
    String(compareBaseRaw)
      .replace(/[^0-9,.-]+/g, '')
      .replace(/\./g, '')
      .replace(',', '.')
  );
  if (!isFinite(compareBase)) return;

  var newCompare = compareBase + (price - originalPrice);
  $compare[0].innerHTML = currency + newCompare.toFixed(2).replace('.', ',');
});


$(document).on('click', '.header-mobile-menu-list-item.collection-item.has-submenu .icon', function (){
    $(this).closest('.header-mobile-menu-list-item').addClass('open')
});
$(document).on('click', '.header-mobile-menu-list-item .mobile-menu-submenu-header', function (){
    $(this).closest('.header-mobile-menu-list-item').removeClass('open')
});
$(document).on('click', '.header-mobile-menu-list-item.has-accordion .icon', function (){
    $(this).closest('.header-mobile-menu-list-item').toggleClass('open');
    $(this).closest('.header-mobile-menu-list-item').find('.header-mobile-menu-list-item-accordion').slideToggle();
});
$(document).on('click', '#headerMenuBtn', function (e) {
    e.preventDefault();
    $('#header-mobile-menu').addClass('open');
    $('body').addClass('header-mobile-menu-opened');
});

$(document).on('click', '.header-mobile-menu-close', function (){
    $('#header-mobile-menu').removeClass('open');
    $('body').removeClass('header-mobile-menu-opened');
});
$(document).on('click', '.js-language-selector a', function (e){
    e.preventDefault();
    updateLocalization($(this).attr('href'));
});
function updateLocalization(language) {
    const formId = crypto.randomUUID();
    const formHtml = `
        <form id="${formId}" action="/localization" method="POST" hidden>
          <input name="_method" value="PUT">
          <input name="language_code" value="${language}">
          <input name="return_to" value="${location.pathname}">
        </form>
      `;
    document.body.insertAdjacentHTML("beforeend", formHtml);
    document.getElementById(formId).submit();
}




// cart 
